import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableCellOnActionEvent, TableConstructorData } from 'src/app/interfaces/tables.interfaces';

@Component({
  selector: 'app-table-users-list',
  templateUrl: './table-users-list.component.html',
  styleUrls: ['./table-users-list.component.scss'],
})
export class TableUsersListComponent {
  @Input({ required: true }) public tableConstructorData: TableConstructorData;
  @Input({ required: true }) public noUsersHint: string;

  @Input({ required: false }) public isExpired = false;
  @Input({ required: false }) public redirectToLoginIfNoSession = false;

  @Output() public action: EventEmitter<TableCellOnActionEvent> = new EventEmitter<TableCellOnActionEvent>();

  public onAction(event: TableCellOnActionEvent): void {
    this.action.emit(event);
  }
}
